module.exports = __webpack_public_path__ + "static/media/mc-logo.877b7d4f.png";